import React, { useState, useRef, useEffect } from "react";
import { FaBars, FaTwitter } from "react-icons/fa";
import { links, social } from "./data";
import logo from "./logo.svg";

const Navbar = () => {
    const [showLinks, setShowLinks] = useState(false);

    const linksContainerRef = useRef(null);
    const linksRef = useRef(null);

    useEffect(() => {
        if (showLinks) {
            const linksHeight = linksRef.current.getBoundingClientRect().height;
            linksContainerRef.current.style.height = `${linksHeight}px`;

            console.log(linksHeight);
        }

    }, [showLinks])

    return (
        <nav>
            <div className="nav-center">
                <div className="nav-header">
                    <img src={logo} alt="Coding Addict"></img>
                    <button
                        className="nav-toggle"
                        onClick={() => setShowLinks(!showLinks)}
                    >
                        <FaBars></FaBars>
                    </button>
                </div>
                {showLinks && (
                    <div ref={linksContainerRef} className="links-container show-container">
                        <ul className="links" ref={linksRef}>
                            {links.map((link) => {
                                const { id, url, text } = link;
                                return (
                                    <li key={id}>
                                        <a href={url}>{text}</a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}

                <ul className="social-icons">
                    {social.map((item) => {
                        const { id, url, icon } = item;
                        return (
                            <li key={id}>
                                <a href={url}>{icon}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
